import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { startGscOAuth } from "@/lib/gscOAuth";

const ADMIN_EMAIL = "lorenjordan333@gmail.com";

/**
 * Admin-only launcher for a CLIENT-TARGETED GSC reconnect (Option 2).
 * The link `/admin/connect-gsc?client=<clientId>` lands here; while logged in as the
 * admin, it starts the OAuth flow pre-targeted at that client (the server embeds the
 * clientId in the OAuth state). The admin approves in Google, tokens are written to the
 * specified client, and they return to /gsc-callback. One login, several pre-built links.
 */
const AdminConnectGsc = () => {
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<"checking" | "redirecting" | "error">("checking");

  useEffect(() => {
    (async () => {
      const clientId = new URLSearchParams(window.location.search).get("client");
      if (!clientId) {
        setStatus("error");
        setError("Missing ?client=<clientId> in the URL.");
        return;
      }
      const { data: auth } = await supabase.auth.getUser();
      const email = (auth.user?.email ?? "").toLowerCase();
      if (!auth.user) {
        setStatus("error");
        setError("Not logged in. Log in as the admin first, then click the link again.");
        return;
      }
      if (email !== ADMIN_EMAIL) {
        setStatus("error");
        setError("Forbidden — this launcher is admin-only.");
        return;
      }
      try {
        setStatus("redirecting");
        await startGscOAuth(clientId); // redirects to Google's consent screen
      } catch (e: any) {
        setStatus("error");
        setError(e?.message || "Could not start the GSC OAuth flow.");
      }
    })();
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background text-foreground">
      <div className="max-w-md text-center px-4">
        {status === "error" ? (
          <div className="text-sm font-mono text-red-500">{error}</div>
        ) : (
          <div className="text-sm font-mono text-muted-foreground">
            {status === "redirecting" ? "Redirecting to Google…" : "Preparing GSC reconnect…"}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminConnectGsc;
